// indentExtension.js
import { Extension } from '@tiptap/core'

const Indent = Extension.create({
  name: 'indent',

  addOptions() {
    return {
      types: ['paragraph', 'heading', 'listItem'], // Apply indent to these node types
      maxIndent: 7, // Maximum indent level
      minIndent: 0, // Minimum indent level
    }
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          indent: {
            default: 0,
            parseHTML: element => {
              const indent = parseInt(element.style.marginLeft || '0', 10) / 30
              return indent >= 0 ? indent : 0
            },
            renderHTML: attributes => {
              if (!attributes.indent || attributes.indent <= 0) {
                return {}
              }
              return {
                style: `margin-left: ${attributes.indent * 30}px`,
              }
            },
          },
        },
      },
    ]
  },

  addCommands() {
    return {
      indent:
        () =>
          ({ state, dispatch }) => {
            const { $from, $to } = state.selection
            let updated = false

            state.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
              if (this.options.types.includes(node.type.name)) {
                const currentIndent = node.attrs.indent || 0
                if (currentIndent < this.options.maxIndent) {
                  if (dispatch) {
                    state.tr.setNodeMarkup(pos, null, {
                      ...node.attrs,
                      indent: currentIndent + 1,
                    })
                  }
                  updated = true
                }
              }
            })

            return updated
          },
      outdent:
        () =>
          ({ state, dispatch }) => {
            const { $from, $to } = state.selection
            let updated = false

            state.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
              if (this.options.types.includes(node.type.name)) {
                const currentIndent = node.attrs.indent || 0
                if (currentIndent > this.options.minIndent) {
                  if (dispatch) {
                    state.tr.setNodeMarkup(pos, null, {
                      ...node.attrs,
                      indent: currentIndent - 1,
                    })
                  }
                  updated = true
                }
              }
            })

            return updated
          },
    }
  },

  addKeyboardShortcuts() {
    return {
      Tab: () => this.editor.commands.indent(),
      'Shift-Tab': () => this.editor.commands.outdent(),
    }
  },
})

export default Indent